
const formList = {
    //维护销售价格表
    priceListAdmin: {
        jurHead: [
            {
                entityField: "start",
                fieldType: "date",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: null,
                extractId: null,
                setField: null,
                showField: "开始时间",
            },
            {
                entityField: "end",
                fieldType: "date",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: null,
                extractId: null,
                setField: null,
                showField: "结束时间",
            },
            {
                entityField: "bgmName",
                fieldType: "search",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: 853533363572736,
                extractId: null,
                setField: 'bgmName,bgmId',
                showField: "通用名称",
            },
            {
                entityField: "cmName",
                fieldType: "search",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: 3391151360249856,
                extractId: null,
                setField: 'cmName,cmId',
                showField: "客户名称",
            },

        ],
        tableList: [
            {
                showField: "商品编码",
                entityField: "bgmCode",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "通用名称",
                entityField: "bgmName",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "客户名称",
                entityField: "cmName",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "创建时间",
                entityField: "createTime",
                isShow: 1,
                fieldType: 'date',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "最高售价",
                entityField: "highPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "最低售价",
                entityField: "lowestPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "生产商",
                entityField: "manufacturer",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "备注",
                entityField: "remark",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "规格",
                entityField: "spec",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "建议售价",
                entityField: "suggestedPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "更新时间",
                entityField: "updateTime",
                isShow: 1,
                fieldType: 'date',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
        ],
        formList: [
            {
                jciId: 1,
                jciType: 1,
                isShowForm: 0,
                jciName: "维护价格表",
                jurconfigform: [
                    {
                        chineseField: "客户名称",
                        showField: "客户名称",
                        entityField: "cmName",
                        fieldType: "search",
                        searchId: 3391151360249856,
                        setField: "cmName,cmId",
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "通用名称",
                        showField: "通用名称",
                        entityField: "bgmName",
                        fieldType: "search",
                        searchId: 853533363572736,
                        setField: "bgmName,bgmId,spec,manufacturer",
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "规格",
                        showField: "规格",
                        entityField: "spec",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 0,
                        isUpdate: 0,
                        isShow: 1,
                    },
                    {
                        chineseField: "生产厂商",
                        showField: "生产厂商",
                        entityField: "manufacturer",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 0,
                        isUpdate: 0,
                        isShow: 1,
                    },
                    {
                        chineseField: "最高售价",
                        showField: "最高售价",
                        entityField: "highPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "最低售价",
                        showField: "最低售价",
                        entityField: "lowestPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "建议售价",
                        showField: "建议售价",
                        entityField: "suggestedPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "备注",
                        showField: "备注",
                        entityField: "remark",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 0,
                    },
                ]
            }
        ]
    },
    //维护采购价格表
    pricePuListAdmin: {
        jurHead: [
            {
                entityField: "start",
                fieldType: "date",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: null,
                extractId: null,
                setField: null,
                showField: "开始时间",
            },
            {
                entityField: "end",
                fieldType: "date",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: null,
                extractId: null,
                setField: null,
                showField: "结束时间",
            },
            {
                entityField: "bgmName",
                fieldType: "search",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: 4439374514425856,
                extractId: null,
                setField: 'bgmName,bgmId',
                showField: "通用名称",
            },
            {
                entityField: "smName",
                fieldType: "search",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: 3386264207560704,
                extractId: null,
                setField: 'smName,smId',
                showField: "供应商名称",
            },

        ],
        tableList: [
            {
                showField: "商品编码",
                entityField: "bgmCode",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "通用名称",
                entityField: "bgmName",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "供应商名称",
                entityField: "smName",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "创建时间",
                entityField: "createTime",
                isShow: 1,
                fieldType: 'date',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "最高售价",
                entityField: "highPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "最低售价",
                entityField: "lowestPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "生产商",
                entityField: "manufacturer",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "备注",
                entityField: "remark",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },

            {
                showField: "规格",
                entityField: "spec",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "建议售价",
                entityField: "suggestedPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "更新时间",
                entityField: "updateTime",
                isShow: 1,
                fieldType: 'date',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
        ],
        formList: [
            {
                jciId: 1,
                jciType: 1,
                isShowForm: 0,
                jciName: "维护价格表",
                jurconfigform: [
                    {
                        chineseField: "供应商名称",
                        showField: "供应商名称",
                        entityField: "smName",
                        fieldType: "search",
                        searchId: 3386264207560704,
                        setField: "smName,smId",
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "通用名称",
                        showField: "通用名称",
                        entityField: "bgmName",
                        fieldType: "search",
                        searchId: 4439374514425856,
                        setField: "bgmName,bgmId,spec,manufacturer",
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "规格",
                        showField: "规格",
                        entityField: "spec",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 0,
                        isUpdate: 0,
                        isShow: 1,
                    },
                    {
                        chineseField: "生产厂商",
                        showField: "生产厂商",
                        entityField: "manufacturer",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 0,
                        isUpdate: 0,
                        isShow: 1,
                    },
                    {
                        chineseField: "最高售价",
                        showField: "最高售价",
                        entityField: "highPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "最低售价",
                        showField: "最低售价",
                        entityField: "lowestPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "建议售价",
                        showField: "建议售价",
                        entityField: "suggestedPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "备注",
                        showField: "备注",
                        entityField: "remark",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 0,
                    },
                ]
            }
        ]
    },
    //销售价目表审批
    priceListAdminAudit: {
        jurHead: [
            {
                entityField: "start",
                fieldType: "date",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: null,
                extractId: null,
                setField: null,
                showField: "开始时间",
            },
            {
                entityField: "end",
                fieldType: "date",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: null,
                extractId: null,
                setField: null,
                showField: "结束时间",
            },
            {
                entityField: "bgmName",
                fieldType: "search",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: 4439374514425856,
                extractId: null,
                setField: 'bgmName,bgmId',
                showField: "通用名称",
            },
            {
                entityField: "smName",
                fieldType: "search",
                formatterContent: null,
                isRequired: 0,
                isShow: 1,
                searchId: 3386264207560704,
                extractId: null,
                setField: 'smName,smId',
                showField: "供应商名称",
            },

        ],
        tableList: [
            {
                showField: "商品编码",
                entityField: "bgmCode",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "通用名称",
                entityField: "bgmName",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "供应商名称",
                entityField: "smName",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "创建时间",
                entityField: "createTime",
                isShow: 1,
                fieldType: 'date',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "最高售价",
                entityField: "highPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "最低售价",
                entityField: "lowestPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "生产商",
                entityField: "manufacturer",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "备注",
                entityField: "remark",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },

            {
                showField: "规格",
                entityField: "spec",
                isShow: 1,
                fieldType: 'string',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "建议售价",
                entityField: "suggestedPrice",
                isShow: 1,
                fieldType: 'number',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
            {
                showField: "更新时间",
                entityField: "updateTime",
                isShow: 1,
                fieldType: 'date',
                formatterContent: null,
                fieldWeight: 120,
                riftField: null,
                isRift: 0
            },
        ],
        formList: [
            {
                jciId: 1,
                jciType: 1,
                isShowForm: 0,
                jciName: "维护价格表",
                jurconfigform: [
                    {
                        chineseField: "供应商名称",
                        showField: "供应商名称",
                        entityField: "smName",
                        fieldType: "search",
                        searchId: 3386264207560704,
                        setField: "smName,smId",
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "通用名称",
                        showField: "通用名称",
                        entityField: "bgmName",
                        fieldType: "search",
                        searchId: 4439374514425856,
                        setField: "bgmName,bgmId,spec,manufacturer",
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "规格",
                        showField: "规格",
                        entityField: "spec",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 0,
                        isUpdate: 0,
                        isShow: 1,
                    },
                    {
                        chineseField: "生产厂商",
                        showField: "生产厂商",
                        entityField: "manufacturer",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 0,
                        isUpdate: 0,
                        isShow: 1,
                    },
                    {
                        chineseField: "最高售价",
                        showField: "最高售价",
                        entityField: "highPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "最低售价",
                        showField: "最低售价",
                        entityField: "lowestPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "建议售价",
                        showField: "建议售价",
                        entityField: "suggestedPrice",
                        fieldType: "number",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 1,
                    },
                    {
                        chineseField: "备注",
                        showField: "备注",
                        entityField: "remark",
                        fieldType: "string",
                        searchId: "",
                        setField: null,
                        jcfId: 1,
                        defaultValue: "",
                        isChange: 1,
                        isShow: 1,
                        isUpdate: 1,
                        isRequired: 0,
                    },
                ]
            }
        ]
    }
}
export default formList